<div *ngIf="!isCategorySelected" class="help-modal-header" mat-dialog-title>
	<div>
		<h5>What can we help you with?<br>Choose a category below to get started</h5>
		<img class="flipman" src="../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
	</div>

	<div class="closeBtn" (click)="closeModal()">
		<img src="../../../../../assets/images/crossbtn.svg" />
	</div>
</div>
<mat-dialog-content [ngClass]="{'lanscapeSubCatHeight': selectedSubcat, 'lanscapeCatHeight': !selectedSubcat}" [ngStyle]="{'max-height': (selectedSubcat && selectedSubcat.type === 'contact') ? '80vh' : '65vh'}">
<div style="position: relative;" *ngIf="!isCategorySelected; else categorySelectedTemplate">
	<!-- <h3>Help & Support</h3> -->
	<!-- <img src="../../../../../assets/images/creation.png" alt="">
	<img src="../../../../../assets/images/management.png" alt="">
	<img src="../../../../../assets/images/analytics.png" alt="">
	<img src="../../../../../assets/images/learn.png" alt="">
	<img src="../../../../../assets/images/rewards.png" alt="">
	<img src="../../../../../assets/images/store.png" alt=""> -->

	<!-- <div>
		<h5>What can we help you with?<br>Choose a category below to get started</h5>

		<img class="flipman" src="../assets/gifs/fixed_gif_transparent.gif" alt="" loop>
	</div>

	<div class="closeBtn" (click)="closeModal()">
		<img src="../../../../../assets/images/crossbtn.svg" />
	</div> -->

	<div id="categories_section" [ngClass]="{'isOneCatPresent': supportCategoriesData?.length === 1}" *ngIf="isUserLoggedIn">
		<!-- <div #boxElement [ngStyle]="{'height': dyanamicWidth ? dyanamicWidth + 'px' : 'unset'}" *ngFor="let category of supportCategoriesData" (click)="selectCategory(category)"> -->
		<div *ngFor="let category of supportCategoriesData" (click)="selectCategory(category)">
			<img class="icon" [src]="category.icon" alt="">
			<span>{{ category.name }}</span>
		</div>
	</div>

	<div id="categories_section" [ngClass]="{'isOneCatPresent': noLoginCategories?.length === 1}" *ngIf="!isUserLoggedIn">
		<!-- <div #boxElement [ngStyle]="{'height': dyanamicWidth ? dyanamicWidth + 'px' : 'unset'}" *ngFor="let category of noLoginCategories" (click)="selectCategory(category)"> -->
		<div *ngFor="let category of noLoginCategories" (click)="selectCategory(category)">
			<img class="icon" [src]="category.icon" alt="">
			<span>{{ category.name }}</span>
		</div>
	</div>
</div>

<ng-template #categorySelectedTemplate>
	<div id="category-selected-header">
		<!-- <div> -->
		<!-- <button class="back_btn" mat-button mat-raised-button (click)="openMainHelpPage()">
			<img src="../../../../../assets/images/back_button1.svg" alt="">
		</button> -->
		<!-- </div> -->
		<div (click)="openMainHelpPage()" class="arrow-back">
			<mat-icon >arrow_back</mat-icon>
		</div>
		<h4>{{ selectedCategory.name }}</h4>
	</div>

	<div id="subcat-head">
		<div [ngClass]="{'border_bottom': selectedSubcat.type == subcat.type}" class="head"
			*ngFor="let subcat of selectedCategory.subCategories; let i = index" (click)="selectSubcat(subcat)">
			<span [ngClass]="{'active-tab': selectedSubcat.type == subcat.type}">
				{{ subcat.name }}
			</span>

		</div>
	</div>

	<div id="subcat-body">

		<div class="videos" *ngIf="selectedSubcat.type === 'video'">
			<ng-container *ngFor="let item of selectedSubcat.data">
				<div class="video_card">
					<video width="320" height="240" (click)="openVideoModal(item.url)">
						<source [src]="item.url" type="video/mp4">
						<source [src]="item.url" type="video/ogg">

					</video>
					<div (click)="openVideoModal(item.url)" class="play"><img
							src="../../../../../assets/images/play_button_icon.svg" alt=""></div>
				</div>

			</ng-container>
		</div>

		<div *ngIf="selectedSubcat.type === 'faq'">

			<mat-accordion>
				<mat-expansion-panel *ngFor="let item of selectedSubcat.data; let i = index">
					<mat-expansion-panel-header>
						<mat-panel-title>
							<div class="ques">
								{{i+1}}. {{item.question}}
							</div>

						</mat-panel-title>
					</mat-expansion-panel-header>
					<div class="answer">
						{{item.answer}}
					</div>

				</mat-expansion-panel>
			</mat-accordion>

		</div>

		<div *ngIf="selectedSubcat.type === 'contact'">

			<form class="contact_form" *ngIf="showForm">

				<div class="left_container">
					<h2>Please enter your contact details</h2>

					<div class="flex emailAddress">
						<!-- <h3>
							Your Email Address
						</h3> -->
						<!-- <span class="inputHead">Email address</span> -->
						<input [disabled]="shouldEmailBeDisabled" name="email" [(ngModel)]="contactEmail" matInput
							placeholder="Enter email address" />
					</div>

					<div class="flex" style="width: 100% !important">
						<!-- <h3>
							Enter Brand
						</h3> -->
						<mat-form-field class="brandInputField" appearance="fill">
							<input placeholder="Enter Brand" class="brandInput" name="brand" matInput type="text"
								[(ngModel)]="selectedOrganizationName" (input)="filterOrganizations()" [matAutocomplete]="auto" />
							<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
								<mat-option [value]="org" *ngFor="let org of filteredOrganizations">
									{{ org }}
								</mat-option>
							</mat-autocomplete>
						</mat-form-field>
					</div>

					<div class="flex">
						<!-- <h3>
							Your Full Name
						</h3> -->
						<input name="store" [(ngModel)]="store" matInput placeholder="Enter store" />
					</div>

					<div class="flex">
						<!-- <h3>
							Your Full Name
						</h3> -->
						<input [disabled]="isUserLoggedIn" name="name" [(ngModel)]="fullName" matInput
							placeholder="Enter full name" />
					</div>

					<div class="flex">
						<!-- <h3>
							Your UserName
						</h3> -->
						<input [disabled]="isUserLoggedIn" name="userName" [(ngModel)]="userName" matInput
							placeholder="Enter Username" />
					</div>

				</div>

				<div class="right_container">
					<div class="flex">
						<h3>
							Select Contact Reason
						</h3>
						<mat-form-field class="reason-field-box" appearance="fill" name="selectedContactReason">
							<mat-label>Reason</mat-label>
							<mat-select [(ngModel)]="selectedContactReason" name="selectedContactReason">
								<mat-option *ngFor="let reason of selectedSubcat.data; let i = index"
									[value]="reason.reason" (click)="changeReason(i, reason.reason)">
									{{ reason.reason }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div class="flex" id="instruction_field" *ngIf="selectedSubcat.data[selectedReasonIndex].instruction">
						<!-- <span class="instruction">Instructions</span> -->
						{{ selectedSubcat.data[selectedReasonIndex].instruction }}
					</div>

					<div class="flex">
						<!-- <h3>
							Message
						</h3> -->
						<textarea name="contactMessage" [(ngModel)]="contactMessage" id="" rows="3"
							placeholder="Enter Message"></textarea>
					</div>

					<div class="file-upload">
						<input type="file" id="upload" class="inputfile" multiple (change)="onFileSelect($event)"
							accept=".jpg, .png, .jpeg, .avif" />
						<label for="upload" class="fileUploadBtn">
							<img src="../../../../../assets/images/file_upload_icon.png" alt="">
							{{ files.length > 0 ? 'Add' : 'Please Upload Screenshots Here' }}
						</label>


					</div>

					<ul class="fileList">
						<li *ngFor="let file of files; let i = index">
							{{i+1}} . {{ file.name }}
							<button class="remove" (click)="removeFile(i)">
								<!-- <img src="../../../../../assets/images/crossbtn.svg" alt=""> -->
								Remove
							</button>
						</li>
					</ul>
				</div>



			</form>
			<button *ngIf="showForm" (click)="createSupportRequest()" class="submit">Submit</button>

			<div class="text" *ngIf="!showForm">
				<p>
					Thanks so much for reaching out!
				</p>
				<p>
					Confirmation has been sent to your email.
				</p>
				<p>
					Our team will connect within 24 hours or sooner.
				</p>
				<button (click)="openMainHelpPage()" class="visit_button">Visit Main Help Page</button>
			</div>

		</div>
	</div>
</ng-template>
</mat-dialog-content>

<!-- <div class="modall" *ngIf="newVisitorIntroduction == 'true'">
		<div class="modal-contentt">
		  <video class="videoPlayerFullModal" #videoPlayer width="100%" height="100%" controls autoplay>
			<source src="../../../../../assets/images/videoSample.mp4" type="video/mp4">
		  </video>
		  <button class="closeBtn" (click)="closeIntroVideo()">
			<img src="../../../../../assets/images/close.png" alt="">
		  </button>
		</div>
</div> -->